import React from 'react';
import Select from 'react-select';

const OrderActions = ({
  isLoading,
  selectedProductType,
  onCancel,
  newOrder,
  companies,
  selectedFirma,
  setSelectedFirma,
  lastSentFirma,
  selectedFirmaKumas,
  setSelectedFirmaKumas,
  lastSentFirmaKumas,
  selectedFirmaMekanizma,
  setSelectedFirmaMekanizma,
  lastSentFirmaMekanizma,
  selectedFirmaMotor,
  setSelectedFirmaMotor,
  lastSentFirmaMotor,
  selectedFirmaAksesuar,
  setSelectedFirmaAksesuar,
  lastSentFirmaAksesuar,
  handleWhatsAppSend,
  handleKatlamaliWhatsAppSend,
  customSelectStyles
}) => {
  return (
    <div className="form-actions">
      <div className="action-buttons">
        <button
          type="submit"
          className="save-btn"
          disabled={isLoading || !selectedProductType}
        >
          {isLoading ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="cancel-btn"
          disabled={isLoading}
        >
          İptal
        </button>
      </div>

      {/* WhatsApp Gönderme Bölümü - Sağ tarafta */}
      {selectedProductType && (newOrder.productName || (selectedProductType === 'plise' && newOrder.pliseProduct1Name)) && newOrder.roomName && (
        <div className="whatsapp-section-right">
          {selectedProductType === 'katlamaliPerde' ? (
            /* Katlamalı Perde için Özel 4'lü Firma Seçimi */
            <div className="katlamali-whatsapp-grid">
              {[
                { id: 'kumas', label: 'Kumaş Firması', value: selectedFirmaKumas, setter: setSelectedFirmaKumas, lastSent: lastSentFirmaKumas },
                { id: 'mekanizma', label: 'Mekanizma Firması', value: selectedFirmaMekanizma, setter: setSelectedFirmaMekanizma, lastSent: lastSentFirmaMekanizma },
                { id: 'motor', label: 'Motor Firması', value: selectedFirmaMotor, setter: setSelectedFirmaMotor, lastSent: lastSentFirmaMotor },
                { id: 'aksesuar', label: 'Aksesuar Firması', value: selectedFirmaAksesuar, setter: setSelectedFirmaAksesuar, lastSent: lastSentFirmaAksesuar }
              ].map((item) => (
                <div key={item.id} className="whatsapp-control-row">
                  <div className="whatsapp-row-header">
                    <span className="row-label">{item.label}</span>
                    {item.lastSent && (
                      <span className="row-sent-info">
                        <i className="fas fa-check"></i> {item.lastSent.name}
                      </span>
                    )}
                  </div>
                  <div className="whatsapp-controls">
                    <Select
                      options={companies.map(firma => ({ value: firma.id, label: firma.name }))}
                      value={item.value ? { value: item.value, label: companies.find(f => f.id === item.value)?.name } : null}
                      onChange={(option) => item.setter(option ? option.value : '')}
                      className="firma-select"
                      isDisabled={isLoading}
                      isClearable
                      isSearchable
                      placeholder="Firma Seçin"
                      styles={customSelectStyles}
                    />
                    <button
                      type="button"
                      onClick={() => handleKatlamaliWhatsAppSend(item.id)}
                      disabled={!item.value || isLoading}
                      className="whatsapp-btn"
                      title={`${item.label} bilgilerini gönder`}
                    >
                      <i className="fab fa-whatsapp"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            /* Diğer Ürünler için Standart Firma Seçimi */
            <>
              {lastSentFirma && (
                <div className="whatsapp-info">
                  <i className="fas fa-check-circle"></i>
                  <span>{lastSentFirma.name} firmasına bilgiler iletildi</span>
                </div>
              )}

              <div className="whatsapp-controls">
                <Select
                  options={companies.map(firma => ({ value: firma.id, label: firma.name }))}
                  value={selectedFirma ? { value: selectedFirma, label: companies.find(f => f.id === selectedFirma)?.name } : null}
                  onChange={(option) => setSelectedFirma(option ? option.value : '')}
                  className="firma-select"
                  isDisabled={isLoading}
                  isClearable
                  isSearchable
                  placeholder="Firma Seçin"
                  noOptionsMessage={() => "Firma bulunamadı"}
                  filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                  styles={customSelectStyles}
                />
                <button
                  type="button"
                  onClick={handleWhatsAppSend}
                  disabled={!selectedFirma || isLoading || !selectedProductType}
                  className="whatsapp-btn"
                  title="Seçilen firmaya WhatsApp ile gönder"
                >
                  <i className="fab fa-whatsapp"></i>
                  <span>Gönder</span>
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderActions;
